<template>
  <v-col
    :cols="block.cols"
    :xs="block.colsxs"
    :sm="block.colssm"
    :md="block.colsmd"
    :lg="block.colslg"
    :xl="block.colsxl"
    :offset="block.offset"
    :class="block.class ? block.class : 'primary--text text-h4'"
    v-html="block.label"
  />
</template>

<script>
export default {
   name: 'Label',

   props: {
      block: {
         type: Object,
         required: true,
      }
   },
}
</script>
